import Vue from 'vue';

export const WebSocketEventBus = new Vue();
